/**校验表单 */
import { regex } from '@/constants/regex'

//常规表单验证， 调用时需参数：验证的提示语msg
export const ruleNormal: any = (msg: string) => {
  return { required: true, message: msg, trigger: ["blur", "change"] };
};

//自定义正则验证表单， 调用时需参数：正则表达式pattern，验证的提示语msg
export const rulePattern: any = (pattern: any, msg: string) => {
  return {
    // required: true,
    pattern: pattern,
    message: msg,
    trigger: ["blur", "change"]
  };
};

//校验教龄，限制最多2位小数点
export const validateTeacherAge = (rule, value, callback) =>{
  let regx = regex.twoDecimalPoint.rules;
  if(value && value !== "") {
    if(parseFloat(value) > 120) {
      callback(new Error("请输入不为0且不超过120的正数"));
    }
    else if(!regx.test(value)) {
       callback(new Error(regex.twoDecimalPoint.label));
    }
    else {
    callback();
  }
  }else {
    callback();
  }
}

//教龄不能为0
export const blurTeacherAge = (rule, value, callback) => {
  if(value == '0') {
   if(callback) {
     callback(new Error("请输入正确的教龄"))
   }
  }else {
    if(callback) callback();
  }
}

//校验手机号码
export const validatePhone = (rule, value, callback) =>{
  validateEvent(rule, value, callback,regex.phone.rules, regex.phone.label )
}


//校验身份证号
export const validateCard = (rule, value, callback) =>{
  validateEvent(rule, value, callback,regex.card.rules, regex.card.label )
}


//校验年龄
export const validateAge = (rule, value, callback) =>{
  validateEvent(rule, value, callback, regex.age.rules, regex.age.label )
}

//校验无效率
export const validateMaxHundredTwoPoint = (rule, value, callback) =>{
  validateEvent(rule, value, callback, regex.maxHundredTwoPoint.rules, regex.maxHundredTwoPoint.label )
}

//校验评卷量
export const validateTwoDecimalPoint = (rule, value, callback) =>{
  validateEvent(rule, value, callback, regex.twoDecimalPoint.rules, regex.twoDecimalPoint.label )
}

//校验开户行信息
export const validateOpeningBank = (rule, value, callback) =>{
  validateEvent(rule, value, callback, regex.openingBank.rules, regex.openingBank.label )
}

//校验银行卡号
export const validateBankCard = (rule, value, callback) =>{
  validateEvent(rule, value, callback, regex.bankCard.rules, regex.bankCard.label )
}

//校验简介
export const validateIntroduction = (rule, value, callback) =>{
  validateEvent(rule, value, callback, regex.introduction.rules, regex.introduction.label )
}

//校验地址
export const validateAddress = (rule, value, callback) =>{
  validateEvent(rule, value, callback, regex.address.rules, regex.address.label )
}

//校验邮箱
export const validateEmail = (rule, value, callback) =>{
  validateEvent(rule, value, callback, regex.email.rules, regex.email.label )
}

//校验方法
export const validateEvent = (rule, value, callback, regx, label) =>{
  if(value == '0' || (value && value !== "")) {
    if(!regx.test(value)) {
       callback(new Error(label));
    }
    else {
    callback();
  }
  }else {
    callback();
  }
}

 //校验姓名
export const validateMax32 = (rule, value, callback) =>{
  if(value && value !== "") {
    if(strLen(value) > 32) {
      callback(new Error("请输入不超过32位字符"));
    }
    else {
    callback();
  }
  }else {
    callback();
  }
}

 //校验姓名
 export const validateMax12 = (rule, value, callback) =>{
  if(value && value !== "") {
    if(strLen(value) > 12) {
      callback(new Error("请输入不超过12位字符"));
    }
    else {
    callback();
  }
  }else {
    callback();
  }
}

/**
 * 取字符长度
 * @param str  输入值
 * 返回字符数
 */
export const strLen = (str: string)=>{
  var realLength = 0, len = str.length, charCode = -1;  
  for (var i = 0; i < len; i++) {  
      charCode = str.charCodeAt(i);  
      if (charCode >= 0 && charCode <= 128) realLength += 1;  
      else realLength += 2;  
  }  
  return realLength
}